import React, { useMemo, useCallback, MouseEvent } from 'react';

import styles from './GeoLabel.css';
import { IGeoLabel } from '../../types/geo';

interface IGeoLabelProps extends IGeoLabel {
  onLabelClick(type: string, geoType: string): void;
}

export function GeoLabel({ url, label, type, geoType, onLabelClick }: IGeoLabelProps) {
  const Elem = useMemo(() => (url ? 'a' : 'span'), [url]);

  const handleClick = useCallback(
    (e: MouseEvent<HTMLElement>) => {
      e.stopPropagation();

      onLabelClick(type, geoType);
    },
    [onLabelClick, type, geoType],
  );

  return (
    <Elem className={styles['link']} href={url} target="_blank" onClick={handleClick}>
      {label}
    </Elem>
  );
}
